import React from 'react';

import { getDeviceColor } from '../constants';

import { TrapStatus } from 'api/InteractiveMap/types';

interface Props {
  caughtPests: number;
  percentageOfFilling: number;
  status: TrapStatus;
  number: string | number;
  activityLabel?: string;
}

const SbsSvg: React.FC<Props> = ({ percentageOfFilling, status, number, activityLabel }) => {
  const color = getDeviceColor(status);
  const counterFontSize = 12;
  const textColor = status === TrapStatus.warning ? 'black' : 'white';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="61" viewBox="0 0 50 50" fill="none">
      <rect
        width="20"
        height="20"
        x="23"
        y="17"
        rx="0"
        ry="0"
        fill={color}
        transform="rotate(-45 28.28 36.5)"
        stroke="black"
        strokeWidth="1"
      />
      <text
        x="50%"
        y="27"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="black"
        fontWeight="bold"
        fontSize={counterFontSize}
        style={{ fontFamily: 'sans-serif', fill: textColor }}
      >
        {activityLabel ? activityLabel : percentageOfFilling || 0}
      </text>

      <text
        x="50%"
        y="10"
        textAnchor="middle"
        fill="black"
        fontSize="18"
        style={{ fontFamily: 'sans-serif' }}
        fontWeight="bold"
      >
        {number}
      </text>
    </svg>
  );
};

export default SbsSvg;
